<template>
  <div class="flex">
    <div
      v-if="paymentMethod.hasOwnProperty('id')"
      class="flex"
    >
      <SimpleSVG
        class="card p-6 m-6"
        filepath="/svg/chart.svg"
        height="50"
        style=" width: 100px !important;"
        width="50"
      />
      <div class="w-2/3 m-4 pt-1">
        <span>
          <strong
            class="uppercase"
            v-text="'Credit Card'"
          />
        </span>
        <div
          v-if="!loading"
          class="pt-4 flex flex-col"
        >
          <span class="py-1 text-black">
            <strong v-text="`${brand} ****${lastFour}`" />
          </span>
          <span
            class="py-1"
            v-text="`Expires: ${expiration}`"
          />
          <span class="py-1 uppercase">
            <strong>
              <a
                @click="openAddPaymentMethodModal"
                v-text="'Edit'"
              />
            </strong>
          </span>
        </div>
      </div>
    </div>
    <div
      v-else
      class="flex"
    >
      <SimpleSVG
        class="card p-6 m-0"
        filepath="/svg/chart.svg"
        height="50"
        style=" width: 100px !important;"
        width="50"
      />
      <div class="w-2/3 m-4 pt-1 self-center">
        <span>
          <strong
            class="uppercase"
            v-text="'No Payment Method Available'"
          />
        </span>
      </div>
    </div>
    <AddPaymentMethodModal
      :show="showAddPaymentMethodModal"
      @close="closeAddPaymentMethodModal"
      @processing="loading = true"
    />
  </div>
</template>

<script type="text/babel">
import { mapActions, mapGetters } from 'vuex'
import { SimpleSVG } from 'vue-simple-svg'
import { startCase } from 'lodash'
import AddPaymentMethodModal from './_modals/AddPaymentMethodModal'

export default {
  name: 'PaymentMethod',
  components: {
    SimpleSVG,
    AddPaymentMethodModal,
  },
  data() {
    return {
      loading: true,
      showAddPaymentMethodModal: false,
    }
  },
  computed: {
    ...mapGetters({
      paymentMethod: 'paymentDefaultPaymentMethod',
    }),
    brand() {
      return startCase(this.paymentMethod.card.brand)
    },
    expiration() {
      return `${this.paymentMethod.card.exp_month}/${this.paymentMethod.card.exp_year}`
    },
    lastFour() {
      return this.paymentMethod.card.last4
    },
  },
  mounted() {
    this.fetchPaymentMethod()
  },
  methods: {
    ...mapActions([
      'paymentsGetPaymentMethods',
    ]),
    openAddPaymentMethodModal() {
      this.showAddPaymentMethodModal = true
    },
    closeAddPaymentMethodModal() {
      this.showAddPaymentMethodModal = false
      this.loading = false
    },
    fetchPaymentMethod() {
      this.paymentsGetPaymentMethods().then(() => {
        this.loading = false
      })
    },
  },
}
</script>
